module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "detalle-doc"
  }, [(_vm.solicitud) ? _c('v-expansion-panel', {
    attrs: {
      "popout": ""
    }
  }, [((_vm.$store.state.user.id_rol === 4 || _vm.$store.state.user.id_rol === 3)) ? _c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Datos del firmante del documento ")])]), _vm._v(" "), _c('v-card', {
    staticClass: "pagos"
  }, [_c('v-card-text', [_c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "name": "documento_nombre",
      "label": "Ha sido firmado por:",
      "disabled": _vm.$store.state.user.id_rol === 4
    },
    model: {
      value: (_vm.solicitud.firmante_documento_nombre),
      callback: function($$v) {
        _vm.$set(_vm.solicitud, "firmante_documento_nombre", $$v)
      },
      expression: "solicitud.firmante_documento_nombre"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "name": "documento_cargo",
      "label": "Quien actúa en calidad de:",
      "disabled": _vm.$store.state.user.id_rol === 4
    },
    model: {
      value: (_vm.solicitud.firmante_documento_cargo),
      callback: function($$v) {
        _vm.$set(_vm.solicitud, "firmante_documento_cargo", $$v)
      },
      expression: "solicitud.firmante_documento_cargo"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "input-group--focused",
    attrs: {
      "name": "documento_entidad",
      "label": "Está revestido del sello/timbre",
      "disabled": _vm.$store.state.user.id_rol === 4
    },
    model: {
      value: (_vm.solicitud.firmante_documento_entidad),
      callback: function($$v) {
        _vm.$set(_vm.solicitud, "firmante_documento_entidad", $$v)
      },
      expression: "solicitud.firmante_documento_entidad"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.state.user.id_rol === 3) ? _c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Departamento donde se enviara el documento para firma")])]), _vm._v(" "), _c('v-card', {
    staticClass: "pagos"
  }, [_c('v-card-text', [_c('v-select', {
    attrs: {
      "label": "Regional",
      "items": _vm.regionales
    },
    model: {
      value: (_vm.solicitud.departamento),
      callback: function($$v) {
        _vm.$set(_vm.solicitud, "departamento", $$v)
      },
      expression: "solicitud.departamento"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Vigencia del documento")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('h5', {
    staticClass: "documento-validez"
  }, [_vm._v("El documento tiene "), _c('strong', [_vm._v(" " + _vm._s(Math.abs(Math.floor((_vm.solicitud.fecha_inicio -
    _vm.solicitud.fecha_fin) / 86400000))) + " " + _vm._s(Math.abs(Math.floor((_vm.solicitud.fecha_fin - _vm.solicitud.fecha_inicio) / 86400000)) <= 1 ? 'día' : 'días'))]), _vm._v(" de vigencia.")]), _vm._v(" "), (_vm.solicitud.fecha_inicio_show) ? _c('select-date', {
    attrs: {
      "model": "fecha_inicio",
      "value": _vm.solicitud.fecha_inicio,
      "disabled": _vm.isDisabled,
      "required": true,
      "label": "Valido desde el"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.solicitud.fecha_fin_show) ? _c('select-date', {
    attrs: {
      "model": "fecha_fin",
      "value": _vm.solicitud.fecha_fin,
      "disabled": _vm.isDisabled,
      "required": true,
      "label": "Hasta el"
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', {
    attrs: {
      "value": true
    }
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Datos del documento")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('h4', {
    staticClass: "margin-0"
  }, [_vm._v(_vm._s(_vm.solicitud.documento_nombre) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n            " + _vm._s(_vm.solicitud.documento_descripcion) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.solicitud.documento_entidad_nombre))])]), _vm._v(" "), (_vm.solicitud.observacion) ? _c('v-alert', {
    attrs: {
      "color": "warning",
      "value": "true"
    }
  }, [_c('strong', [_vm._v("Observación.-")]), _vm._v(" " + _vm._s(_vm.solicitud.observacion) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('strong', [_vm._v("Número de apostilla:")]), _vm._v(" " + _vm._s(_vm.solicitud.nro_apostilla || 'Pendiente') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Código de seguridad:")]), _vm._v(" " + _vm._s(_vm.solicitud.cod_seguridad || 'Pendiente') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de expedición:")]), _vm._v(" " + _vm._s(_vm.$datetime.format(_vm.solicitud.fecha_expedicion) || 'Pendiente') + "\n        ")], 1)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Datos del solicitante")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('strong', [_vm._v("Nombre completo:")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_solicitante_nombres) + " " + _vm._s(_vm.solicitud.tramite_solicitante_primer_apellido) + " " + _vm._s(_vm.solicitud.tramite_solicitante_segundo_apellido) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.solicitud.tramite_solicitante_tipo_documento) + ":")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_solicitante_nro_documento) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de nacimiento:")]), _vm._v(" " + _vm._s(_vm.formato_fecha(_vm.solicitud.tramite_solicitante_fecha_nacimiento)) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Email:")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_solicitante_email) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Teléfono:")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_solicitante_telefono) + "\n        ")])], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Datos de la solicitud")])]), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('strong', [_vm._v("Código de seguimiento:")]), _vm._v(" " + _vm._s(_vm.solicitud.tramite_cod_seguimiento) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de solicitud:")]), _vm._v(" " + _vm._s(_vm.$datetime.format(_vm.solicitud.tramite_fecha_inicio)) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de culminación:")]), _vm._v(" " + _vm._s(_vm.$datetime.format(_vm.solicitud.tramite_fecha_fin) || 'Pendiente')), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Tipo de apostilla: ")]), _vm._v(" "), (_vm.solicitud.digital) ? _c('span', [_vm._v("Digital")]) : _c('span', [_vm._v("Física")]), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Departamento: ")]), _vm._v(" " + _vm._s(_vm.solicitud.departamento)), _c('br'), _vm._v(" "), _vm._l((_vm.solicitud.otros), function(value, key) {
    return _c('span', [(value.nombre) ? _c('strong', [_vm._v(_vm._s(value.nombre) + ": ")]) : _vm._e(), (value.value) ? _c('span', [_vm._v(_vm._s(value.value))]) : _vm._e(), _c('br')])
  })], 2)], 1)], 1), _vm._v(" "), _c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('strong', {
    staticClass: "primary--text"
  }, [_vm._v("Pagos")])]), _vm._v(" "), _c('v-card', {
    staticClass: "pagos"
  }, [_vm._l((_vm.pagos), function(item, index) {
    return [_c('v-card-text', [_c('h5', {
      staticClass: "primary--text"
    }, [_c('v-icon', {
      attrs: {
        "color": "primary"
      }
    }, [_vm._v("monetization_on")]), _vm._v("\n              PAGO " + _vm._s(item.tipo) + "\n            ")], 1), _vm._v(" "), _c('strong', [_vm._v("CPT:")]), _vm._v(" "), (item.cpt) ? _c('span', [_vm._v(_vm._s(item.cpt.cpt))]) : _c('span', [_vm._v("Pendiente de generarse")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Fecha de pago:")]), _vm._v(" " + _vm._s(_vm.$datetime.format(item.fecha_pago) || 'Pendiente') + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Estado:")]), _vm._v(" " + _vm._s(item.estado) + " "), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Titular del pago:")]), _vm._v(" " + _vm._s(item.titular_factura) + " -\n            "), _c('strong', [_vm._v(_vm._s(item.tipo_documento) + ":")]), _vm._v(" " + _vm._s(item.nro_documento) + "\n          ")]), _vm._v(" "), (index + 1 < _vm.pagos.length) ? _c('v-divider') : _vm._e()]
  })], 2)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1a7dd3be","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/eRegister/tramiteDoc/DetalleDoc.vue
// module id = 497
// module chunks = 2